import React from "react";
import { ExternalDirectiveResearch } from "./ExternalDirectiveResearch";

export const OutdoorResearch = () => (
  <ExternalDirectiveResearch
    eurLexUrl="https://eur-lex.europa.eu/legal-content/EN/TXT/?uri=CELEX:32000L0014"
    i18nPrefix="steps.questionaire.outdoor.research"
  />
);
